"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnchorInput = void 0;
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var theme_1 = require("../theme");
var anchor_input_style_1 = require("./anchor.input.style");
var bearing_input_1 = require("./bearing.input");
var distance_input_1 = require("./distance.input");
var input_select_1 = require("./input.select");
(0, theme_1.addStyles)(anchor_input_style_1.Style);
exports.AnchorInput = {
    view: function (state, ctrl, field) {
        return (0, mithril_1.m)('div', {
            className: anchor_input_style_1.CSS.container,
            onclick: function (e) { return ctrl.selectAnchorField(e, field); }
        }, [
            input_select_1.SelectInputComponent.view(state.placement),
            (0, mithril_1.m)('div', {
                className: anchor_input_style_1.CSS.relatedSpans
            }, [
                input_select_1.SelectInputComponent.view(state.relatedSpans[0]),
                input_select_1.SelectInputComponent.view(state.relatedSpans[1])
            ]),
            (0, mithril_1.m)('div', { className: anchor_input_style_1.CSS.inputs }, [
                (0, mithril_1.m)('div', { className: anchor_input_style_1.CSS.leftInput }, distance_input_1.DistanceInput.view(state.distance)),
                (0, mithril_1.m)('div', { className: anchor_input_style_1.CSS.rightInput }, bearing_input_1.BearingInput.view(state.bearing))
            ]),
            state.hasError() ? (0, mithril_1.m)('span', { className: anchor_input_style_1.CSS.MDL.error + ' ' + anchor_input_style_1.CSS.error }, (0, i18n_1.Translate)(state.error)) : null
        ]);
    }
};
//# sourceMappingURL=anchor.input.js.map